export const stringArrayJoiner = (array, delimiter = ' • '): string => {
    return array.filter(Boolean).join(delimiter);
};
